<template>
	<db-row class="group-list-wrapper ovh" valign="middle">
		<db-row width="20" class="aside-bar" align="center" height="auto">
			<db-label v-for="(letter, idx) in letters" color="#2d90ff" :key="idx">{{letter}}</db-label>
		</db-row>
		<db-scroller class="group-scroller">
			<db-row v-for="(list, letter, idx) in list" :key="idx" height="auto">
				<db-col valign="middle" class="group-item-header" height="80"><db-label color="#999">{{letter}}</db-label></db-col>
				<db-row class="pd-0-30">
					<db-col @click="chose(row)" class="group-item" valign="middle" height="80" v-for="(row, idx2) in list" :key="idx2">
						<db-label>{{row.text}}</db-label>
						<db-col class="auto-fill" height="auto" align="right"><db-label color="#999">{{row.code}}</db-label></db-col>
					</db-col>
				</db-row>
			</db-row>
		</db-scroller>
	</db-row>
</template>

<script>
	export default {
		name: 'group-list',
		
		props: {
			list: {
				type: Object
			}
		},
		
		computed: {
			letters(){
				return (this.list && Object.keys(this.list).length > 0) ? Object.keys(this.list) : []
			}
		},
		
		methods: {
			chose(item){
				this.$emit('chose', item)
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.group-list-wrapper{
		position: relative;
		
		.aside-bar{
			position: absolute;
			right: 10px;
			transition: translateY(-50px);
			z-index: 1;
		}
		
		.group-item-header{
			background: #F0F0F0;
			padding: 0 30px;
		}
		
		.group-item{
			border-bottom: solid 1px #E5E5E5;
			padding: 0 10px 0 0;
			
			&:last-child{
				border-bottom: none;
			}
		}
	}
</style>
